import { Experiment } from '@cian/experiments/ab';
import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import { ETabType } from '../../types/filters';
import { PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT } from '../../constants/experiments';

import * as style from './Filters.css';

export interface IFiltersProps {
  type: ETabType | null;
  onAdvertisementsClick(): void;
  onJKClick(): void;
  onSavedSearchClick(): void;
}

export const Filters: React.FC<IFiltersProps> = ({ type, onAdvertisementsClick, onJKClick, onSavedSearchClick }) => {
  return (
    <div className={style['container']}>
      <div className={style['filters']}>
        <div className={style['filters-header']}>
          <div className={style['header']}>Избранное</div>
        </div>
        <div className={style['row']}>
          <ul className={style['favorites-type']}>
            <Experiment name={PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT} group="B">
              <li
                onClick={onAdvertisementsClick}
                {...mergeStyles(
                  style['favorites-type-item'],
                  (type === ETabType.Аdvertisements || type === null) && style['favorites-type-item--active'],
                )}
              >
                Объявления
              </li>
            </Experiment>
            <Experiment name={PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT} group="A" default>
              <li
                onClick={onAdvertisementsClick}
                {...mergeStyles(
                  style['favorites-type-item'],
                  type !== ETabType.JK && style['favorites-type-item--active'],
                )}
              >
                Объявления
              </li>
            </Experiment>
            <li
              onClick={onJKClick}
              {...mergeStyles(
                style['favorites-type-item'],
                type === ETabType.JK && style['favorites-type-item--active'],
              )}
            >
              Жилые комплексы
            </li>
            <Experiment name={PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT} group="B">
              <li
                onClick={onSavedSearchClick}
                {...mergeStyles(
                  style['favorites-type-item'],
                  type === ETabType.SavedSearches && style['favorites-type-item--active'],
                )}
              >
                Сохранённые поиски
              </li>
            </Experiment>
          </ul>
        </div>
      </div>
    </div>
  );
};
